import React from "react";
import { t } from "@lingui/macro";
import { helperToast } from "lib/helperToast";
import { RxExclamationTriangle } from "react-icons/rx";
import "./style.css";

const notifications = {};

export function pushAccessNotification() {
  const id = 'access error';
  if (notifications[id]) {
    return;
  }

  const errorText = t`You don't have early access, come back on July 14.`

  notifications[id] = true;

  helperToast.error(
    <div className="flex items-center gap-[1rem] tailwind isolate">
      <RxExclamationTriangle className="text-red h-[2.7rem]"/>
      <div className="text-red text-[1.4rem]">{errorText}</div>
    </div>
  , {
    hideProgressBar: true,
    className: 'Toast-access-error'
  });
}
